export const LOCALES = Object.freeze({
  en: 'English',
  es: 'Español',
  'pt-BR': 'Português (Brasil)',
  fr: 'Français',
  de: 'Deutsch',
});
export function validLocale(value) {
  return Object.hasOwn(LOCALES, value);
}
